import React from "react";
import { translate } from "../../../../common/providers";
import styles from "./MembersListEmptyState.module.css";

export default function MembersListEmptyState({ isSearching = false }) {
	if (isSearching) {
		return (
			<div className={styles["members-list__empty-state"]}>
				<div className={styles["members-list__empty-state-title"]}>
					{translate("team-management.members.members-list.empty-state.search")}
				</div>
			</div>
		);
	}
	return (
		<div className={styles["members-list__empty-state"]}>
			<div className={styles["members-list__empty-state-title"]}>
				{translate("team-management.members.members-list.members-list.empty-state.title")}
			</div>
			<div className={styles["members-list__empty-state-sub-title"]}>
				{translate("team-management.members.members-list.empty-state.content")}
			</div>
		</div>
	);
}
